import { Box, Grid, Typography } from '@mui/material';
import MultipleCheckBoxes from '../../../AddLocation/Components/UI/MultipleCheckBoxes';
import {
  detailsTitle,
  detailsValue,
  billinglabelTitle
} from '../../../../assets/styles/appStyles';
import CheckboxInput from '../../../AddLocation/Components/UI/CheckboxInput';
import { gridContainer, infoGridItem } from '../../Styles/CustodianAddressDetailsStyles';

export default function BillingInfoInvoicingDetails({
  invoiceBeforeRecords,
  billingInfoInvoicingPaymentMethods,
  paymentMethods,
}: {
  paymentMethods: any[];
  invoiceBeforeRecords: boolean;
  billingInfoInvoicingPaymentMethods: string[];
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
      <Grid container item rowSpacing={3}>
        <Grid item xs={12} sx={infoGridItem}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <MultipleCheckBoxes
                options={paymentMethods}
                keyName={''}
                label="Invoicing payment method"
                selectedValues={billingInfoInvoicingPaymentMethods}
                toggleChange={() => { }}
                labelStyle={billinglabelTitle}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography sx={billinglabelTitle}>Invoicing</Typography>
              <Box sx={detailsValue}>
                <CheckboxInput
                  keyName=""
                  label="Invoice before records"
                  onBlur={() => { }}
                  onChange={() => { }}
                  checked={invoiceBeforeRecords}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
